<template>
    <div class="yanzheng" :class="errCode ? 'error' : ''">
      <base-input
        :isNumber="isNumber"
        :ph="placeholder"
        :value="value"
        @input="$emit('input', $event)"
        @focus="$emit('focus')"
        :limitLen="inputLimitLen"
      />
      <button :class="{disabled: yanzhenging}" :disabled="yanzhenging" @click="vertifyCode()">{{ yzText }}</button>
      <ypsdk ref="ypsdk"/>
    </div>
</template>

<script>
import baseInput from './base-input'
import BTime from 'best-calendar'
// 图形验证sdk
import ypsdk from '@/components/ypsdk/ypsdk'

export default {
  data() {
      return {
        yzText: '获取验证码',
        yanzhenging: false
      }
  },
  props: {
    phone: String,
    email: String,
    value: String,
    scene: {
      type: String,
      default: 'phone'
    },
    action: {
      type: String,
      default: 'bind'
    },
    placeholder: {
      type: String,
      default: '输入验证码'
    },
    limitLen: {
      type: Number,
      default: 0
    },
    isNumber: {
      type: Boolean,
      default: true
    },
    errCode: {
      type: String,
      default: ''
    }
  },
  computed: {
    inputLimitLen() {
      if (this.limitLen) return this.limitLen
      return this.scene === 'email' ? 6 : 4
    }
  },
  created() {
    this.phoneReg = /^1[3456789]\d{9}$/;
    this.emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
    this.firstPicValid = true;
  },
  methods: {
    getLocale() {
      if (typeof navigator === 'undefined') return 'zh-CN'
      return navigator.language || (navigator.languages && navigator.languages[0]) || 'zh-CN'
    },

    vertifyCode(captchaVerifyParam) {
      if (this.scene === 'email') {
        return this.sendEmailCode()
      }
      if (!this.phoneReg.test(this.phone)) {
        return this.$emit('wrongPhone')
      }
      if (this.yanzhenging) return;
      this.yanzhenging = true;
      const params = {
        action: 'bind',
        phone: this.phone
      }
      if (captchaVerifyParam) {   // 图片验证
        params.captcha_verify_param = captchaVerifyParam;
      }
      this.countDown = new BTime.CountDown(60000, 0);
      this.countDown.on('timing', time => {
        this.yzText = `(${time.second}秒)`;
      });
      this.countDown.on('timend', () => {
        this.yanzhenging = false;
        this.yzText = '获取验证码';
      });
      // 发送验证码请求
      return this.$fetch.post({
        url: '/captcha',
        params
      }).then((data) => {
        if (data.need_captcha && this.firstPicValid) {
          // 图形验证
          this.firstPicValid = false;
          this.ypValid();
        }else {
          // 直接获取验证码
          this.firstPicValid = true;
        }
        return data;
      }, (e) => {
        if (!e.success && e.error_text.includes('图形验证') && this.firstPicValid) {
          this.firstPicValid = false;
          return this.ypValid();
        }
        this.firstPicValid = true;
        this.openMessage(0, e.error_text || '获取验证码失败');
        this.countDown && this.countDown.stop(true);
        if (captchaVerifyParam) return Promise.reject(e);
      })
    },

    sendEmailCode() {
      if (!this.emailReg.test(this.email || '')) {
        return this.$emit('wrongEmail')
      }
      if (this.yanzhenging) return;
      this.yanzhenging = true;
      this.countDown = new BTime.CountDown(60000, 0);
      this.countDown.on('timing', time => {
        this.yzText = `(${time.second}秒)`;
      });
      this.countDown.on('timend', () => {
        this.yanzhenging = false;
        this.yzText = '获取验证码';
      });
      this.$fetch.post({
        url: '/email-code/send',
        params: {
          action: this.action,
          email: this.email,
          locale: this.getLocale()
        }
      }).catch((e) => {
        this.openMessage(0, e.error_text || '获取验证码失败');
        this.countDown && this.countDown.stop(true);
      })
    },

    ypValid() {
      this.countDown && this.countDown.stop(true);
      this.$nextTick(() => {
        this.$refs.ypsdk.ready(
          captchaVerifyParam => this.vertifyCode(captchaVerifyParam)
        ).then(() => {}, () => {});
      })
    }
  },
  beforeDestroy() {
    if (this.countDown) {
      this.countDown.stop();
    }
  },
  components: {
    baseInput,
    ypsdk
  }
}
</script>

<style lang="scss" scoped>
.yanzheng {
  display: flex;
  align-items: center;
  margin-top: 10px;

  /deep/ .ipt {
    margin-top: 0;
    flex: 2.3;
  }

   /deep/ input {
    border-radius: 6px 0 0 6px;
  }

  button {
    flex: 1;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #08A681;
    border-radius: 0 6px 6px 0;
    font-size: 14px;
    color: #FFFFFF;

    &.disabled {
      background: #CCCCCC;
    }
  }
}

.error {
  border: 2px solid #E51C23;
  border-radius: 8px;
}
</style>
